import { useId } from 'react'
import { useAuth } from '../auth/AuthContext'
import type { Membership } from '../api/types'

/*
  The ranch switcher (brief §2.6): a user in more than one ranch chooses which one is
  active. Tenant comes from membership, never from the hostname. A command captured
  under the previous ranch still syncs under it (scope stamped at capture time).
*/
function key(m: Membership): string {
  return `${m.organization.publicId}/${m.ranch?.publicId ?? ''}`
}

export function RanchSwitcher() {
  const { memberships, activeMembership, switchRanch } = useAuth()
  const id = useId()
  const ranches = memberships.filter((m) => m.ranch !== null)

  return (
    <label htmlFor={id} className="visuallyHidden-wrap">
      <span className="visuallyHidden">Ranch</span>
      <select
        id={id}
        data-testid="ranch-switcher"
        value={activeMembership ? key(activeMembership) : ''}
        onChange={(event) => {
          const next = ranches.find((m) => key(m) === event.target.value)
          if (next) switchRanch(next)
        }}
      >
        {ranches.map((m) => (
          <option key={key(m)} value={key(m)}>
            {m.ranch!.name}
            {m.organization.name !== m.ranch!.name ? ` · ${m.organization.name}` : ''}
          </option>
        ))}
      </select>
    </label>
  )
}
